<template>

  <el-container id="root_container" style="padding: 0px;margin: 0px; overflow: hidden;">

    <el-header class="headerManu">
      <div style="height: 60px;background-color: transparent;float: left; margin-left: 20px; display: flex;flex-direction: row;justify-content: start;" @click="goHome()">
        <img  :src="logo"  style="float: left;width: 50px;height: 50px;margin-top: 5px;"/>
        <div style="background-color: transparent; color: white; height: 60px; display: flex;flex-direction: column;justify-content: start; padding-left: 10px;">
          <div class="BSD_TITLE">Global Change Risk Map Platform</div>
          <div class="BSD_SUBTITLE">of Population and Economic Systems</div>
        </div>
      </div>
    </el-header>


    <el-main id="router_view" style="background-color: #F5F7FA;width: 100%;height: 500px;text-align: center;">

      <div id="form_container" style="width: 70%;background-color: white;margin-left: 15%;margin-top: 10px;border-radius: 3px;display: flex;flex-direction: row;justify-content: center;">

        <div style="margin-top: 5%;">

          <el-col style="width: 400px; padding: 20px 40px; border: solid 1px lightgrey;border-radius: 3px; height: auto;box-shadow: 0px 0px 5px lightgrey; ">
            <el-row style="background-color: transparent;">
              <p style="height: 30px;line-height: 30px;font-size: 20px; font-weight: bold; font-family: 'Microsoft YaHei'">Reset Password</p>
            </el-row>

            <el-row style="margin-top: 20px;">
              <el-input placeholder="password" v-model="newpassword" show-password></el-input>
            </el-row>

            <el-row style="margin-top: 20px;">
              <el-input placeholder="confirm password" v-model="newpasswordConfirm" show-password></el-input>
            </el-row>


            <el-row style="margin-top: 25px;">

              <el-button type="primary" style="width: 100%; font-size: 17px;" @click="passwordReset" :disabled="newpassword ==undefined || newpassword.length==0 || newpasswordConfirm==undefined || newpasswordConfirm.length==0">Sumbit</el-button>

            </el-row>

            <el-divider></el-divider>

            <el-row style="text-align: center;padding: 15px 0px;font-size: 14px;">
              <a href="/#/BNUMap/Login" style="color:deepskyblue;font-weight: bold;font-size: 17px;">I HAVE MY PASSWORD </a>
            </el-row>

          </el-col>
        </div>

      </div>
    </el-main>

  </el-container>
</template>

<script>

  import {api_bnu_saveNewPassword} from "@/api";
  import {Notify} from "vant";

  let bsd_logo =  require( '../../../src/assets/icons/earth.png');
  export default {
    name: "ResetPassword",
    data(){
      return {
        logo:bsd_logo,
        newpassword:undefined,
        newpasswordConfirm:undefined,
      }
    },
    methods:{
      goHome(){
        this.$router.push({path:'/BNUMap/cc'})
      },
      reSign(){
        this.$router.push({path:'/BNUMap/Login'})
      },
      /**
       *
       * */
      passwordReset(){

        let postParams = {
          mail:this.$route.query.email,
          password:this.newpassword,
          repassword:this.newpasswordConfirm,
          sid:this.$route.query.sid,
        };
        console.log("SaveNewPassword && data = ",postParams);
        let _this = this;
        api_bnu_saveNewPassword(postParams).then(res=>{
          let resData = res.data;
          console.log("Save new password = ",resData);
          if(resData.code==200000){
            this.$alert('Password reset successful, please log in again', 'Prompt', {
              confirmButtonText: 'OK',
              callback: action => {
                _this.reSign();
              }
            });
          }
        }).catch(() => {
          Notify({ type: "danger", message: "请求失败" });
        });

      }
    },

    mounted() {
      document.getElementById("router_view").style.height = document.body.clientHeight - 60 +"px";
      document.getElementById("form_container").style.height = document.body.clientHeight - 60 - 20 +"px";
    }
  }
</script>




<style scoped lang="scss">
@import "BSDMap";

.headerManu{
 cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/BSD/ResetPassword.vue